import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import dayjs from "dayjs";

import { useSessionContext } from "../../../contexts/SessionContext";
import { CommonDialog } from "../../../components/common/CommonDialog";
import { FormButtonGroup } from "../../../components/form";
import { PatchRelatedPerson } from "../../../services/fhir/relatedperson/PatchRelatedPerson";
import { APPC_CONSENT } from "../../../services/appc";

export function ActivateConsentDialog({
  isOpen,
  setIsOpen,
  row,
  type,
  setType,
}: any) {
  const { setRefetch, user } = useSessionContext();
  const [loading, setLoading] = useState<boolean>(false);

  const isActivation = type === "Add";
  const dependentName = row?.name ?? "dependente";

  const handleConfirm = async () => {
    try {
      setLoading(true);
      if (type === "Remove") {
        await PatchRelatedPerson({
          id: row?.relatedId,
          operation: "replace",
          path: "/period",
          content: {
            end: dayjs().toISOString(),
          },
        });

        await PatchRelatedPerson({
          id: row?.relatedId,
          operation: "replace",
          path: "/active",
          content: false,
        });

        await APPC_CONSENT({
          rule: "Deny",
          patient_id: row?.identifier?.replace(/[.-]/g, ""),
          subject_id: [user?.username],
          cnes: null,
        });
        setRefetch((prev: any) => !prev);
      } else {
        await PatchRelatedPerson({
          id: row?.relatedId,
          operation: row?.start ? "replace" : "add",
          path: "/period",
          content: {
            start: dayjs().toISOString(),
          },
        });

        setRefetch((prev: any) => !prev);
      }
      toast.success(
        `${isActivation ? "Ativação" : "Inativação"} realizada com sucesso!`
      );
    } catch {
      toast.warn(
        "Não foi possível finalizar a operação, por favor tente novamente!"
      );
    } finally {
      handleClose();
    }
  };

  const handleClose = () => {
    setType("");
    setIsOpen(false);
  };

  return (
    <CommonDialog
      handleClose={handleClose}
      isOpen={isOpen}
      sheetTitle={isActivation ? "Ativar dependente" : "Inativar dependente"}
      sheetSubtitle={
        isActivation
          ? `${dependentName} voltará a aparecer como ativo na sua família.`
          : `${dependentName} será inativado e o consentimento será revogado.`
      }
      sheetSize="medium"
      footer={
        <FormButtonGroup
          onGoBackButtonClick={handleClose}
          onNextButtonClick={handleConfirm}
          goBackButtonText="Cancelar"
          nextButtonText="Confirmar"
          loading={loading}
        />
      }
    >
      <Stack spacing={1.5} sx={{ px: 2, pt: 1.5, pb: 2 }}>
        <Typography variant="body2" color="text.secondary" lineHeight={1.5}>
          {isActivation
            ? "Confirme para reativar o cadastro deste dependente."
            : "Confirme para inativar o cadastro. Você poderá reativá-lo depois."}
        </Typography>
      </Stack>
    </CommonDialog>
  );
}
